var map = {
	"./CSS.png": 372,
	"./CSharp.png": 20,
	"./Discord.png": 21,
	"./DvsLogo.png": 505,
	"./FuriosaPeds.png": 988,
	"./Git.png": 633,
	"./GitHub.png": 420,
	"./HTML.png": 354,
	"./JavaScript.png": 804,
	"./MinaPeds.png": 962,
	"./NodeJS.png": 907,
	"./React.png": 392,
	"./elementalpt.png": 534,
	"./perfil.png": 239,
	"./perfil2.png": 525,
	"./playpt.png": 863,
	"./psicoterapia.png": 827,
	"./psicoterapia2.png": 737,
	"./sistematkt.png": 748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;